import * as actionTypes from '../constants/action.types'
import actionCreator from '../utils/actions/creator'

export const submitChangePassword = actionCreator(
  actionTypes.SUBMIT_CHANGE_PASSWORD,
  ({ oldPassword, password }) => ({
    oldPassword,
    password
  })
)

export const submitChangePasswordSucceeded = actionCreator(
  actionTypes.FORM_SUBMIT_SUCCEEDED
)

export const submitChangePasswordFailed = actionCreator(
  actionTypes.FORM_SUBMIT_FAILED,
  error => error
)
